module.exports = __webpack_public_path__ + "img/news-bg3.adae3f11.jpg";